import { LabelsMap } from 'new/form/common/types';

import { otherFundingSectionLabels } from './sections/otherFundingSection/labels';

export const mittweidaFundingDetailsLabelsMap: LabelsMap = {
  ...otherFundingSectionLabels,
};
